<div class="cambiar-password-container">
  <div class="page-header">
    <h1><i class="fas fa-key"></i> Cambiar Contraseña</h1>
    <button class="btn btn-secondary" (click)="cancel()" [disabled]="loading">
      <i class="fas fa-arrow-left"></i> Volver
    </button>
  </div>

  <div class="content">
    <div class="form-card">
      <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
        
        <!-- Success Message -->
        <div class="alert alert-success" *ngIf="successMessage">
          <i class="fas fa-check-circle"></i>
          {{ successMessage }}
        </div>

        <!-- Error Message -->
        <div class="alert alert-danger" *ngIf="errorMessage">
          <i class="fas fa-exclamation-circle"></i>
          {{ errorMessage }}
        </div>

        <!-- Current Password -->
        <div class="form-group">
          <label for="currentPassword">
            <i class="fas fa-lock"></i> Contraseña Actual
            <span class="required">*</span>
          </label>
          <div class="password-input-wrapper">
            <input 
              [type]="showCurrentPassword ? 'text' : 'password'"
              id="currentPassword"
              formControlName="currentPassword" 
              class="form-control" 
              [class.is-invalid]="f.currentPassword.invalid && f.currentPassword.touched"
              placeholder="Ingrese su contraseña actual"
              autocomplete="current-password"
            />
            <button 
              type="button"
              class="password-toggle"
              (click)="togglePasswordVisibility('current')"
              tabindex="-1"
            >
              <i class="fas" [ngClass]="showCurrentPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
            </button>
          </div>
          <div class="invalid-feedback" *ngIf="f.currentPassword.invalid && f.currentPassword.touched">
            La contraseña actual es requerida
          </div>
        </div>

        <!-- New Password -->
        <div class="form-group">
          <label for="newPassword">
            <i class="fas fa-key"></i> Nueva Contraseña
            <span class="required">*</span>
          </label>
          <div class="password-input-wrapper">
            <input 
              [type]="showNewPassword ? 'text' : 'password'"
              id="newPassword"
              formControlName="newPassword" 
              class="form-control" 
              [class.is-invalid]="f.newPassword.invalid && f.newPassword.touched"
              placeholder="Ingrese su nueva contraseña"
              autocomplete="new-password"
            />
            <button 
              type="button"
              class="password-toggle"
              (click)="togglePasswordVisibility('new')"
              tabindex="-1"
            >
              <i class="fas" [ngClass]="showNewPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
            </button>
          </div>
          <div class="invalid-feedback" *ngIf="f.newPassword.hasError('required') && f.newPassword.touched">
            La nueva contraseña es requerida
          </div>
          <div class="invalid-feedback" *ngIf="f.newPassword.hasError('minlength') && f.newPassword.touched">
            La contraseña debe tener al menos 8 caracteres
          </div>
          <div class="invalid-feedback" *ngIf="f.newPassword.hasError('passwordStrength') && f.newPassword.touched">
            La contraseña debe contener {{ getPasswordStrengthErrors().join(', ') }}
          </div>
          <div class="password-requirements">
            <small>
              <i class="fas fa-info-circle"></i>
              La contraseña debe tener al menos 8 caracteres e incluir mayúsculas, minúsculas y números o caracteres especiales.
            </small>
          </div>
        </div>

        <!-- Confirm Password -->
        <div class="form-group">
          <label for="confirmPassword">
            <i class="fas fa-check-circle"></i> Confirmar Nueva Contraseña
            <span class="required">*</span>
          </label>
          <div class="password-input-wrapper">
            <input 
              [type]="showConfirmPassword ? 'text' : 'password'"
              id="confirmPassword"
              formControlName="confirmPassword" 
              class="form-control" 
              [class.is-invalid]="(f.confirmPassword.invalid || changePasswordForm.hasError('passwordMismatch')) && f.confirmPassword.touched"
              placeholder="Confirme su nueva contraseña"
              autocomplete="new-password"
            />
            <button 
              type="button"
              class="password-toggle"
              (click)="togglePasswordVisibility('confirm')"
              tabindex="-1"
            >
              <i class="fas" [ngClass]="showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
            </button>
          </div>
          <div class="invalid-feedback" *ngIf="f.confirmPassword.hasError('required') && f.confirmPassword.touched">
            Debe confirmar la nueva contraseña
          </div>
          <div class="invalid-feedback" *ngIf="changePasswordForm.hasError('passwordMismatch') && f.confirmPassword.touched">
            Las contraseñas no coinciden
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="form-actions">
          <button 
            type="button"
            class="btn btn-outline-secondary"
            (click)="cancel()"
            [disabled]="loading"
          >
            <i class="fas fa-times"></i> Cancelar
          </button>
          <button 
            type="submit" 
            class="btn btn-primary"
            [disabled]="loading || changePasswordForm.invalid"
          >
            <i class="fas" [ngClass]="loading ? 'fa-spinner fa-spin' : 'fa-save'"></i>
            {{ loading ? 'Guardando...' : 'Cambiar Contraseña' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>